import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';
import store from '@/store';
import { ErrorResponse } from '@/utils/response';
import { axios, CustomAxiosResponse } from '@/utils/axios';
import { CourseItem } from './course-item.model';

export interface CourseItemStoreInterface {
  courseItem: CourseItem | null;
  courseItems: CourseItem[];
  error: ErrorResponse | null;
  fetchCourseItemsByCourse(uuid: string): Promise<void>;
  fetchPurchasesByPreCollectionUuid(uuid: string): Promise<void>;
}

@Module({
  namespaced: true,
  dynamic: true,
  name: 'courseItem',
  store,
})
class CourseItemStore extends VuexModule implements CourseItemStoreInterface {
  courseItem: CourseItem | null = null;
  courseItems: CourseItem[] = [];
  error: ErrorResponse | null = null;

  @Mutation
  updateCourseItem(params: CourseItem) {
    this.courseItem = params;
  }

  @Mutation
  updateCourseItems(params: CourseItem[]) {
    this.courseItems = params;
  }

  @Mutation
  setError(params: ErrorResponse) {
    this.error = params;
  }

  @Action
  async fetchCourseItemsByCourse(uuid: string): Promise<void> {
    this.context.commit('updateCourseItems', []);
    this.context.commit('setError', null);

    try {
      const { data }: CustomAxiosResponse = await axios.get(
        `/courses/${uuid}/course-items`,
      );

      this.context.commit('updateCourseItems', data);
    } catch (error) {
      this.context.commit('setError', error);
    }
  }

  @Action
  async fetchPurchasesByPreCollectionUuid(uuid: string): Promise<void> {
    this.context.commit('updateCourseItems', []);
    this.context.commit('setError', null);

    try {
      const { data }: CustomAxiosResponse = await axios.get(
        `/pre-collections/${uuid}/courseItems`,
      );

      this.context.commit('updateCourseItems', data);
    } catch (error) {
      this.context.commit('setError', error);
    }
  }
}

export default getModule(CourseItemStore);
